module.exports = __webpack_public_path__ + "static/media/ewmbg.d74072d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/v2/ewmbg.png
// module id = 721
// module chunks = 2